import { UserResponse, ValidationErrorType, validationError } from "../../../Common";
import { GetResponseAnswerData, MultiResponseAnswerData } from "../../../Common/Commands";
import { useSurveyCtx, useSurveyCtxDispatch, useUserResponseCtx } from "../../../Context/SurveyContext";
import { SurveyEngine_Models_Announce, SurveyEngine_Models_Answer, SurveyEngine_Models_DispoSelect, SurveyEngine_Models_DispoSelectResponse, SurveyEngine_Models_AuthenticateUser, SurveyEngine_Models_AuthenticateUserResponse, SurveyEngine_Models_BaseResponse, SurveyEngine_Models_Block, SurveyEngine_Models_Command, SurveyEngine_Models_DynamicResponse, SurveyEngine_Models_GetResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_GetValue, SurveyEngine_Models_GetValueResponse, SurveyEngine_Models_MultiResponseGrid, SurveyEngine_Models_Slider, SurveyEngine_Models_SliderResponse, SurveyEngine_Models_Scale, SurveyEngine_Models_ScaleResponse, SurveyEngine_Models_PlayValue, SurveyEngine_Models_DynamicResponseResponse, SurveyEngine_Models_MultiResponseResponse, SurveyEngine_Models_ScaleMatrix, SurveyEngine_Models_RecordMessage, SurveyEngine_Models_RecordMessageResponse, SurveyEngine_Models_WebCapture, SurveyEngine_Models_ScaleMatrixResponse, SurveyEngine_Models_FileUpload, SurveyEngine_Models_Ranking, SurveyEngine_Models_RankingResponse, SurveyEngine_Models_WebTransfer, SurveyEngine_Models_Video, SurveyEngine_Models_Recruit, SurveyEngine_Models_SetLanguage, SurveyEngine_Models_SESurveyConfirmOperation, SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_StartGridResponse, SurveyEngine_Models_StartGridQuestion } from "../../../api";
import Announce from "../Announce/Announce";
import { GetResponse } from "../GetResponse/GetResponse";
import { GetValue } from "../GetValue/GetValue";
import { Authenticate } from "../Authenticate/Authenticate";
import { SliderCommand } from "../Slider/Slider";
import { MultiResponse } from "../MultiResponse/MultiResponse";
import { useBlockDispatchCtx } from "../../../Context/BlockContext";
import { DynamicResponse } from "../DynamicResponse/DynamicResponse";
import DispoSelect from "../DispoSelect/DispoSelect";
import { PlayValue } from "../PlayValue/PlayValue";
import { RecordMessage } from "../RecordMessage/RecordMessage";
import { WebCapture } from "../WebCapture/WebCapture";
import { Scale } from "../Scale/Scale";
import { ScaleMatrixNew } from "../ScaleMatrix/ScaleMatrixNew";
import { FileUpload } from "../FileUpload/FileUpload";
import { Ranking } from "../Ranking/Ranking";
import { WebTransfer } from "../WebTransfer/WebTransfer";
import { VideoCommand } from "../Video/VideoCommand";
import { RecruitNew } from "../Recruit/RecruitNew";
import { SetLanguage } from "../SetLanguage/SetLanguage";

interface RenderProps{
    id:number
    NextQuestion:SurveyEngine_Models_Command,
    APIStatusCode:number,
    ValidationError?:validationError
    focus:boolean
    getNextQuestionCommand: (surveySID: string, payLoad: UserResponse, isFirstTime?: boolean) => void,
    getSubmitPendingConfirmation?:(surveySID:string,payLoad:SurveyEngine_Models_RecruitResponse,operation:SurveyEngine_Models_SESurveyConfirmOperation) => void
}
export const RenderCommand = (props: RenderProps) => {
  const surveyCtx = useSurveyCtx();
  let userResCtx = useUserResponseCtx();
  const blockSumToDispatchCtx = useBlockDispatchCtx();
  const surveyCtxDispatch = useSurveyCtxDispatch();
  const updateResponse = (response: SurveyEngine_Models_BaseResponse) => {
    const addIndex = userResCtx.current.findIndex(res => res.commandIndex === response.commandIndex)
    if (addIndex !== -1) {
      userResCtx.current.splice(addIndex, 1)
      //console.log("Removed Response:" + JSON.stringify(userResCtx.current));
    }
    if (response.commandType !== "Remove") {
      userResCtx.current.push(response);
      //console.log(`Added Response: ${JSON.stringify(userResCtx.current)}`);
      if (surveyCtx.NextQuestion.commandType === 'Block') {
        let error: validationError = { commandIndex: response.commandIndex!, commandType: response.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
        surveyCtxDispatch({ type: "removeValidationError", value: error });
        blockSumToDispatchCtx({ type: "ResetCommandIndexFocus", value: false });
      }
    }
    if (surveyCtx.NextQuestion.commandType === 'Block') {
      const cmd = surveyCtx.NextQuestion as SurveyEngine_Models_Block;

      if(cmd.keepOnPage)
      {
        if (cmd.commands?.length === userResCtx.current.length) {
          blockSumToDispatchCtx({ type: "BlockError", value: false })
        }
        if (cmd.sumTo && cmd.sumTo > 0) {
          let sumToValue: number = 0;
          userResCtx.current.forEach((item: SurveyEngine_Models_GetValueResponse) => {
            if (item.value)
              sumToValue = sumToValue + Number(item.value)
          })
          if(sumToValue > 0 )
          {
            blockSumToDispatchCtx({ type: "UpdateSumToValue", value: sumToValue });
          
          }
        }
      }
    }

    if (surveyCtx.NextQuestion.commandType === 'WebCapture' ||
      surveyCtx.NextQuestion.commandType === 'WebTransfer' ||
      surveyCtx.NextQuestion.commandType === 'SetLanguage')
    {
      //Make the next command index the first command index to disable the previous button if WebCapture is the first command
      const isFirstTime =  surveyCtx.NextQuestion.commandType === 'WebCapture' && surveyCtx.NextQuestion.commandIndex === 1
      props.getNextQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!, userResCtx.current, isFirstTime);
    }
  }

  let currentAnswer
  let component = <></>
  switch (props.NextQuestion.commandType) {
    case "Announce":

      let AnnounceQuestion = props.NextQuestion as SurveyEngine_Models_Announce;
      component =
        <Announce
          id={AnnounceQuestion.commandIndex as number}
          message={AnnounceQuestion.message as string}
          callback={updateResponse}
        />
      break;
    case "AuthenticateUser":
      let AuthenticateUserQuestion = props.NextQuestion as SurveyEngine_Models_AuthenticateUser;
      currentAnswer = userResCtx.current.find(r => r.commandIndex === AuthenticateUserQuestion.commandIndex!) as SurveyEngine_Models_AuthenticateUserResponse;
      component =
        <Authenticate
          id={AuthenticateUserQuestion.commandIndex!}
          message={AuthenticateUserQuestion.message!}
          userNameCaption={AuthenticateUserQuestion.usernameCaption!}
          userValue={currentAnswer?.username!}
          passValue={currentAnswer?.password!}
          passwordCaption={AuthenticateUserQuestion.passwordCaption!}
          errorMesage={AuthenticateUserQuestion.errorMessage!}
          isError={props.APIStatusCode === 0 ? false : true}
          callback={updateResponse}
          focus={props.focus}
        />
      break;
    case "DispoSelect":
      let dispoSelectDef = "";
      let dispoSelect = props.NextQuestion as SurveyEngine_Models_DispoSelect

      dispoSelectDef = dispoSelect.answers?.find(e => e.id === -1)?.id?.toString() ?? "";
      currentAnswer = userResCtx.current.find(r => r.commandIndex === dispoSelect.commandIndex!) as SurveyEngine_Models_DispoSelectResponse;
      if (currentAnswer) {
        dispoSelectDef = currentAnswer.selectedId!.toString()
      }

      component =
        <DispoSelect
          id={dispoSelect.commandIndex!}
          answers={dispoSelect.answers!}
          defaultAnswer={dispoSelectDef}
          isError={props.ValidationError ? true : false}
          message={dispoSelect.message!}
          callback={updateResponse}
          focus={props.focus}
        />
      break;
    case "Scale":
      {
        let scaleDef = "";
        let scale = props.NextQuestion as SurveyEngine_Models_Scale

        scale.answers!.map(
          (item: SurveyEngine_Models_Answer) => {
            if (item.isSelected) {
              scaleDef = item.id!.toString();
            }
            return true;
          }
        )

        if(props.ValidationError?.errorType === ValidationErrorType.NO_RESPONSE) scaleDef = "";

        currentAnswer = userResCtx.current.find(r => r.commandIndex === scale.commandIndex!) as SurveyEngine_Models_ScaleResponse;
        if (currentAnswer) {
          scaleDef = currentAnswer.selectedId!.toString()
        }
        component =
          <Scale
            id={scale.commandIndex!}
            answers={scale.answers!}
            defaultAnswer={scaleDef}
            isError={props.ValidationError ? true : false}
            message={scale.message!}
            layout={scale.webOptions ? scale.webOptions.layout!.toString() : "Vertical"}
            callback={updateResponse}
            focus={props.focus}
          />
        break;
      }
    case "ScaleMatrix":
      let scaleMatrixCmd = props.NextQuestion as SurveyEngine_Models_ScaleMatrix;
      currentAnswer = userResCtx.current.find(r => r.commandIndex === scaleMatrixCmd.commandIndex) as SurveyEngine_Models_ScaleMatrixResponse
      const scaleMatrixResAnswers: SurveyEngine_Models_StartGridResponse[] = scaleMatrixCmd.questions!.filter(question => question.defaultValue !== undefined).map((question: SurveyEngine_Models_StartGridQuestion) => {
        let answer:SurveyEngine_Models_StartGridResponse = {
          answerValue: question.defaultValue,
          commandType:"StartGridResponse",
          commandIndex: question.commandIndex
        }
        return answer;
      });
      if (scaleMatrixResAnswers.length > 0) {
        currentAnswer = {
          answers: scaleMatrixResAnswers,
        }
      }
      component = <ScaleMatrixNew 
                  id={scaleMatrixCmd.commandIndex!} 
                  message={scaleMatrixCmd.message!}
                  questions={scaleMatrixCmd.questions!}
                  answers={scaleMatrixCmd.answers!}
                  defaultAnswer={currentAnswer?currentAnswer.answers!:[]}
                  isError={props.ValidationError ? true : false}
                  focus={props.focus}
                  callback={updateResponse}/>
      break;
    case "Ranking":
      let rankingCmd = props.NextQuestion as SurveyEngine_Models_Ranking;
      currentAnswer = userResCtx.current.find(r => r.commandIndex === rankingCmd.commandIndex) as SurveyEngine_Models_RankingResponse
      let isError: boolean = props.ValidationError ? true : false
      if (currentAnswer && currentAnswer.answers?.length !== rankingCmd.questions?.length) {
        isError = true;
      }
      const rankingResAnswers: SurveyEngine_Models_StartGridResponse[] = rankingCmd.questions!.filter(question => question.defaultValue !== undefined).map((question: SurveyEngine_Models_StartGridQuestion) => {
        let answer:SurveyEngine_Models_StartGridResponse = {
          answerValue: question.defaultValue,
          commandType:"StartGridResponse",
          commandIndex: question.commandIndex
        }
        return answer;
      });
      if (rankingResAnswers.length > 0) {
        currentAnswer = {
          answers: rankingResAnswers,
        }
      }
      component = <Ranking
        id={rankingCmd.commandIndex!}
        message={rankingCmd.message!}
        questions={rankingCmd.questions!}
        answers={rankingCmd.answers!}
        defaultAnswer={currentAnswer ? currentAnswer.answers! : []}
        isError={isError}
        focus={props.focus}
        callback={updateResponse} />
      break;      
    case "DynamicResponse":
      let dynamicResponseQuestion = props.NextQuestion as SurveyEngine_Models_DynamicResponse;
      let drDefault: string = '';
      let defaultAnswer = dynamicResponseQuestion.answers?.find((answer) => answer.isSelected);
      if (defaultAnswer) drDefault = defaultAnswer.id!.toString();
     
      currentAnswer = userResCtx.current.find(r => r.commandIndex === dynamicResponseQuestion.commandIndex) as SurveyEngine_Models_DynamicResponseResponse
      if (currentAnswer)
        drDefault = currentAnswer.selectedId!.toString();
     
      if(props.ValidationError?.errorType === ValidationErrorType.NO_RESPONSE) drDefault = "";
      
      component = <DynamicResponse id={dynamicResponseQuestion.commandIndex!}
        question={dynamicResponseQuestion.message!}
        commandType={dynamicResponseQuestion.commandType!}
        answers={dynamicResponseQuestion.answers!}
        defaultAnswer={drDefault!}
        layout={dynamicResponseQuestion.webOptions ? dynamicResponseQuestion.webOptions.layout!.toString() : "Vertical"}
        isError={props.ValidationError ? true : false}
        callback={updateResponse}
        focus={props.focus}
      />
      break;
    case "FileUpload":
      let fileUploadQuestion = props.NextQuestion as SurveyEngine_Models_FileUpload;
      component =
        <FileUpload id={fileUploadQuestion.commandIndex!}
          question={fileUploadQuestion.message!}
          extension={fileUploadQuestion.extension}
          fileDescription={fileUploadQuestion.fileDescription}
          maxSizeMB={fileUploadQuestion.maxSizeMB}
          isError={props.ValidationError ? true : false}
          focus={props.focus}
          originalFileName={fileUploadQuestion.originalFileName!}
          uploadedFileName={fileUploadQuestion.uploadedFileName!}
          callback={updateResponse}
        />
      break;
    case "GetResponse":
      let getResponseQuestion = props.NextQuestion as SurveyEngine_Models_GetResponse;
      let grDefault = ""
      let data: GetResponseAnswerData[] = getResponseQuestion.answers!.map(
        (item: SurveyEngine_Models_Answer) => {
          if (item.isSelected) {
            grDefault = item.id!.toString();
          }
          let answer: GetResponseAnswerData = {
            label: item.message!,
            value: item.id!,
            isOpenEnded: item.isOpenEnded!,
            otherValue: item.otherValue
          }
          return answer;
        }
      )
      currentAnswer = userResCtx.current.find(r => r.commandIndex === getResponseQuestion.commandIndex!) as SurveyEngine_Models_GetResponseResponse;
      if (currentAnswer)
      {
        grDefault = currentAnswer.selectedId!.toString();
        const otherValue = currentAnswer.otherValue ??  "";
        data = data.map(item => item.isOpenEnded && item.value.toString() === grDefault ? {...item, otherValue: otherValue}: item);
      }
     
      if(props.ValidationError?.errorType === ValidationErrorType.NO_RESPONSE) grDefault = "";
      
      component =
        <GetResponse id={getResponseQuestion.commandIndex!}
          question={getResponseQuestion.message!}
          answers={data}
          defaultAnswer={grDefault}
          layout={getResponseQuestion.webOptions ? getResponseQuestion.webOptions.layout!.toString() : "Vertical"}
          columns={getResponseQuestion.webOptions ? getResponseQuestion.webOptions.columns! : 1}
          isError={props.ValidationError ? true : false}
          callback={updateResponse}
          focus={props.focus}
        />
      break;
    case "GetValue":
      let getValueQuestion = props.NextQuestion as SurveyEngine_Models_GetValue;
      let gvDefault = getValueQuestion?.defaultAnswer!;
      currentAnswer = userResCtx.current.find(r => r.commandIndex === getValueQuestion.commandIndex!) as SurveyEngine_Models_GetValueResponse;
      if (currentAnswer) {
        gvDefault = currentAnswer.value!;
      }

      if(props.ValidationError?.errorType === ValidationErrorType.NO_RESPONSE) gvDefault = "";
      
      component =
        <GetValue id={getValueQuestion.commandIndex!}
          question={getValueQuestion.message!}
          confirmQuestion={getValueQuestion.confirmMessage!}
          defaultAnswer={gvDefault}
          isError={props.ValidationError ? true : false}
          focus={props.focus}
          callback={updateResponse}
          maskInput={getValueQuestion.maskInput!}
          inputFormat={getValueQuestion.inputFormat!}
          Validation={{
            dataType: getValueQuestion.validationType?.toString()!,
            confirmResponse: getValueQuestion.confirmResponse!,
            caseSensitive: getValueQuestion.confirmCaseSensitive!,
            characterCount: getValueQuestion.webOptions?.showCharacterCount!,
            minCharacters: getValueQuestion.minimumCharacters!,
            maxCharacters: getValueQuestion.maximumCharacters!,
            postiveNumbersOnly: getValueQuestion.positiveNumberOnly!,
            inputHeight: getValueQuestion.webOptions?.textBoxHeight!,
            CompareList: getValueQuestion.compareList ? getValueQuestion.compareList!.map((e) => { return e.value! }) : []
          }}
        />
      break;
    case "MultiResponse":
      let multiResponseQuestion = props.NextQuestion as SurveyEngine_Models_MultiResponseGrid;

      const currentResponse = userResCtx.current.find(r => r.commandIndex === multiResponseQuestion.commandIndex) as SurveyEngine_Models_MultiResponseResponse

      const multiresponseAnswers: MultiResponseAnswerData[] = multiResponseQuestion.answers!.map(
        (item: SurveyEngine_Models_Answer) => {
          let isSelected = item.isSelected!
          if (currentResponse) {
            var index = currentResponse.answerIds?.findIndex((id) => id === item.id);
            if (index !== -1) isSelected = true;
          }
          let answer: MultiResponseAnswerData = {
            label: item.message!,
            value: item.id!,
            isOpenEnded: item.isOpenEnded!,
            otherValue: item.otherValue,
            isSelected: isSelected
          }
          return answer;
        }
      )

      component = <MultiResponse id={multiResponseQuestion.commandIndex!}
        question={multiResponseQuestion.message!}
        answers={multiresponseAnswers}
        exclusiveId={multiResponseQuestion.exclusiveId}
        layout={multiResponseQuestion.webOptions?.layout!}
        columns={multiResponseQuestion.webOptions?.columns!}
        minAnswers={multiResponseQuestion.minResponses!}
        maxAnswers={multiResponseQuestion.maxResponses!}
        isError={props.ValidationError ? true : false}
        focus={props.focus}
        //isExclusive = {false}
        callback={updateResponse} />
      break;
    case "PlayValue":
      let playValueQuestion = props.NextQuestion as SurveyEngine_Models_PlayValue;
      component = <PlayValue id={playValueQuestion.commandIndex!}
        message={playValueQuestion.message!}
        callback={updateResponse} />
      break;
    case "Recruit":
      console.log("RenderCommand - Recruit")
      let recruitQuestion = props.NextQuestion as SurveyEngine_Models_Recruit;
      component = <RecruitNew id={recruitQuestion.commandIndex!}
                   message={recruitQuestion.message!}
                   studyName={recruitQuestion.studyDisplayName!}
                   studyType={recruitQuestion.studyType!}
                   sessions={recruitQuestion.sessions!} 
                   panelistTimeZone={surveyCtx.panelistTimeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone}
                   calendarRecruitUrl={recruitQuestion.calendarRecruitUrl!}
                   isAcquireAvalibility = {recruitQuestion.isAcquireAvailability!}
                   getNextQuestionCommand={props.getNextQuestionCommand}
                   getSubmitPendingConfirmation={props.getSubmitPendingConfirmation!}
                  />
      break;  
    case "RecordMessage":
      let recordMessageQuestion = props.NextQuestion as SurveyEngine_Models_RecordMessage;
      let rmDefault = recordMessageQuestion?.defaultAnswer!;
      currentAnswer = userResCtx.current.find(r => r.commandIndex === recordMessageQuestion.commandIndex!) as SurveyEngine_Models_RecordMessageResponse;
      if (currentAnswer) {
        rmDefault = currentAnswer.value!;
      }
      if(props.ValidationError?.errorType === ValidationErrorType.NO_RESPONSE) rmDefault = "";
      
      component = 
      <RecordMessage id={recordMessageQuestion.commandIndex!}
        question={recordMessageQuestion.message!}
        confirmQuestion={recordMessageQuestion.confirmMessage!}
        answers={recordMessageQuestion.answers!}
        defaultAnswer={rmDefault}
        maskInput={recordMessageQuestion.maskInput!}
        inputFormat={recordMessageQuestion.inputFormat!}
        inputBoxHeight={recordMessageQuestion.webOptions?.textBoxHeight!}
        Validation={{
          dataType: recordMessageQuestion.validationType?.toString()!,
          confirmResponse: recordMessageQuestion.confirmResponse!,
          caseSensitive: recordMessageQuestion.confirmCaseSensitive!,
          characterCount: recordMessageQuestion.webOptions?.showCharacterCount!,
          minCharacters: recordMessageQuestion.minimumCharacters!,
          maxCharacters: recordMessageQuestion.maximumCharacters!,
        }}
        isError={props.ValidationError ? true : false}
        focus={props.focus}
        callback={updateResponse} />
      break;
    case "SLIDER":
      let sliderQuestion = props.NextQuestion as SurveyEngine_Models_Slider;
      let sliderDefault: number = sliderQuestion.defaultValue!;

      currentAnswer = userResCtx.current.find(r => r.commandIndex === sliderQuestion.commandIndex) as SurveyEngine_Models_SliderResponse
      if (currentAnswer)
        sliderDefault = parseInt(currentAnswer.value!);

      component =
        <SliderCommand id={sliderQuestion.commandIndex!}
          question={sliderQuestion.message!}
          isError={props.ValidationError ? true : false}
          callback={updateResponse}
          minValue={sliderQuestion.minValue!}
          maxValue={sliderQuestion.maxValue!}
          defaultValue={sliderDefault}
          stepValue={sliderQuestion.stepValue!}
          focus={props.focus}
        />
      break;
    case "Video":
      let videoQuestion = props.NextQuestion as SurveyEngine_Models_Video;
      component =
        <VideoCommand id={videoQuestion.commandIndex!}
          videoURL={videoQuestion.videoURL}
          videoHeight={videoQuestion.videoHeight}
          videoWidth={videoQuestion.videoWidth}
          callback={updateResponse}
          focus={props.focus}
        />
      break;
    case "WebCapture":
      let webCaptureQuestion = props.NextQuestion as SurveyEngine_Models_WebCapture;
      component =
        <WebCapture id={webCaptureQuestion.commandIndex!}
          params={webCaptureQuestion.values!} callback={updateResponse}
        />
      break;
    case "WebTransfer":
      let webTransferQuestion = props.NextQuestion as SurveyEngine_Models_WebTransfer;
      component =
        <WebTransfer id={webTransferQuestion.commandIndex!}
          baseUrl={webTransferQuestion.url!}
          OpenInNewWindow={webTransferQuestion.openInNewWindow!}
          callback={updateResponse}
        />
      break;
    case "SetLanguage":
      let setLangQuestion = props.NextQuestion as SurveyEngine_Models_SetLanguage;
      component =<SetLanguage id={setLangQuestion.commandIndex!} language={setLangQuestion.culture??""} callback={updateResponse}/>
      break;
    default:
      component = (<></>)
  }
  return (<div>{component}</div>);
}
